import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationController } from 'infrastructure/antd/controllers/notification-controller';
import { useTranslation } from 'react-i18next';
import dataService from 'services/dataService';
import { apiUnassignTask } from 'services/dataService/resources/oneplatform/api';

import { getTasksByPatientQueryKey } from './use-get-tasks-by-patient';

import type { ITaskCard, IUnassignTaskPayload } from '../types';

export const useUnassignTask = (patientGuid: string) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: ({
      taskGuid,
      returnNote,
    }: { taskGuid: string } & IUnassignTaskPayload) =>
      dataService.createOne<{ task: ITaskCard }>(apiUnassignTask(taskGuid), {
        returnNote,
      }),
    onSuccess: () => {
      notificationController.success({
        message: t('tasksDrawer.returnSuccess'),
      });
      queryClient.invalidateQueries(getTasksByPatientQueryKey(patientGuid));
    },
    onError: () => {
      notificationController.error({
        message: t('tasksDrawer.returnError'),
      });
    },
  });
};
